'use client';
import { Controller } from 'react-hook-form';
import "./style.css";

type Props = {
  label?: string;
  name: string;
  control: any;
  error?: string;
  className?: string;
  onlyNumber?: boolean;
  required?: boolean;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
};

const ControlledTextArea = ({ label, name, control, error, className, onlyNumber, required, maxLength, disabled, placeholder }: Props) => {
  const handleValidation = (value: string) => {
    if (onlyNumber && !/^[0-9]*$/.test(value)) {
      return false;
    }
    return value;
  };

  return (
    <div className="controlled-textarea-container">
      {label && (
        <label htmlFor={name} className={`controlled-textarea-label ${error ? 'error' : ''}`}>
          {label}
          {required && <span className="controlled-textarea-required"> *</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <textarea
            id={name}
            className={`controlled-textarea-input ${error ? 'error' : ''} ${className || ''} ${disabled ? 'disabled' : ''}`}
            value={value || ''}
            onChange={(e) => {
              const validatedValue = handleValidation(e.target.value);
              if (validatedValue !== false) {
                onChange(validatedValue);
              }
            }}
            maxLength={maxLength}
            disabled={disabled}
            placeholder={placeholder}
          />
        )}
      />
      {error && <small className="controlled-textarea-error">{error}</small>}
    </div>
  );
};

export default ControlledTextArea;
